import React, { Component } from 'react'
import {
    Container,
    Row,
    Col,
    ListGroup,
    ListGroupItem
} from 'reactstrap'

import { Icon } from 'react-icons-kit'
import { linkedinSquare } from 'react-icons-kit/fa/linkedinSquare'
import { facebookSquare } from 'react-icons-kit/fa/facebookSquare'
import { phoneSquare } from 'react-icons-kit/fa/phoneSquare'
import { instagram } from 'react-icons-kit/fa/instagram'
import { whatsapp } from 'react-icons-kit/fa/whatsapp'
import Emp from '../../utilitarios/infoEmpresa'
import './social.css'

const empresa = new Emp()

export default class RedesSociales extends Component {

    constructor(props) {
        super(props);
        this.state = {
            infoEmpresa: empresa
        }
    }

    componentWillMount() {
        let _this = this

        empresa.getInfoEmpresa().then(data => {
            _this.setState({
                infoEmpresa: data
            })
        })
    }

    render() {
        return (
            <div>
                <a className="icon iconFb" target="_blank" href="https://en-gb.facebook.com/pg/ElectricaCaporale/about/">
                    <Icon size={30} icon={facebookSquare} />
                </a>

                <a className="icon iconIg" target="_blank" href="https://www.instagram.com/electricacaporale/">
                    <Icon size={30} icon={instagram} />
                </a>

                <a className="icon iconWpp" href={`https://api.whatsapp.com/send?phone=${this.state.infoEmpresa.Whatsapp}&text=Hola%20buen%20dia`}>
                    <Icon size={30} icon={whatsapp} />
                </a>
                <a title={this.state.infoEmpresa.Telefono} className="icon iconTel" href={`tel:+598${this.state.infoEmpresa.Telefono}`} >
                    <Icon size={30} icon={phoneSquare} />
                    <div className="divTel">{this.state.infoEmpresa.Telefono}</div>
                </a>
                {/* <Icon size={30} icon={linkedinSquare} /> */}
            </div>
        )
    }
}